/** 图文消息 */
<template lang="pug">
.doPICTURETEXT
  .title  {{cont.title}}
  .stem  {{cont.stem}}
  img(:src='cont.answer')
</template>
<script>
export default {
  props: ["cont"],
  created() {
    console.log(this.cont);
  }
};
</script>
<style lang="stylus" scoped>
.doPICTURETEXT
  width 100%
  overflow auto
  .title
    font-size 20px
    font-family MicrosoftYaHeiUI-Bold
    font-weight bold
    color rgba(42, 46, 54, 0.8)
    line-height 25px
    margin-bottom 24px
  .stem
    font-size 16px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 0.75)
    line-height 28px
</style>
